import React from 'react';
import axios from 'axios';
import { DashboardShell, TileSection, listCount, useRefreshKey, useAnyVisible } from '../../shared/LiveDashboard';
import { todayInTenant } from '../../shared/tenantClock';
import { productItem, statusOf } from './WeighMeasure/WeighMeasurePage';

// Warehouse Dashboard: a live starter (shared/LiveDashboard.js) — the
// fulfilment queue, what's gone out today, and Units still to weigh.

// Units with no weight or dimensions yet, by Weigh & Measure's own rule.
const unitsToWeigh = () => axios.get('/api/weigh-measure')
  .then((res) => (res.data.data || []).map(productItem).filter((item) => statusOf(item) === 'missing').length);

const QUEUE = [
  { key: 'pick', label: 'Ready to Pick', screen: 'warehouse-pick', icon: 'Ready to Pick', count: listCount('/api/sales-orders', { open_for_picking: 'true', limit: 1 }), to: '/warehouse-pick' },
  { key: 'pack', label: 'Ready to Pack', screen: 'warehouse-pack', icon: 'Ready to Pick', count: listCount('/api/sales-orders', { open_for_packing: 'true', limit: 1 }), to: '/warehouse-pack' },
  { key: 'ship', label: 'Ready to Ship', screen: 'warehouse-ship', icon: 'Backorders', count: listCount('/api/sales-orders', { open_for_shipping: 'true', limit: 1 }), to: '/warehouse-ship' },
];
const today = () => todayInTenant();
const KEY_FIGURES = [
  { key: 'shipped-today', label: 'Shipped Today', screen: 'warehouse-shipments', icon: 'Backorders', count: () => listCount('/api/shipments', { date_from: today(), date_to: today(), limit: 1 })(), to: '/warehouse-shipments' },
  { key: 'weigh', label: 'Units to Weigh & Measure', screen: 'warehouse-weigh-measure', icon: 'Stock On Hand', count: unitsToWeigh, to: '/warehouse-weigh-measure' },
];

function WarehouseDashboard() {
  const [refreshKey, refresh] = useRefreshKey();
  const any = useAnyVisible(QUEUE, KEY_FIGURES);
  return (
    <DashboardShell
      title="Warehouse Dashboard"
      description={any ? 'The fulfilment queue, today’s shipments, and Units still to weigh and measure.' : 'Your Roles don’t include any of this dashboard’s cards.'}
      onRefresh={refresh}
    >
      <TileSection title="Fulfilment Queue" tiles={QUEUE} refreshKey={refreshKey} />
      <TileSection title="Key Figures" tiles={KEY_FIGURES} refreshKey={refreshKey} />
    </DashboardShell>
  );
}

export default WarehouseDashboard;
